import { isEmpty } from 'underscore';
import templateDetailModal from './view/templateDetail';
import viewMarketplaceModal from './view/marketPlaceModalView.js';
import previewTemplateModal from './view/previewTemplate';
import overlay from './view/overlay.js';
const commonFunction = require('../common/common');
const sourceFile = require('../../config/config.js');
const url = sourceFile.url;

function initialize() {}

function openDesignerTemplateModal(getAllTemplates) {
  // pass 1 to get all Active templates of your channle and global.
  // pass 0 to get all templates of your channel.
  $('.component-loader').removeClass('hide');
  let payload = {
    operation: 'getDesignerTemplateList',
    get_all_templates: getAllTemplates
  };
  commonFunction.fnAjaxRequest(
    url + 'Handler/DesignerTemplateHandler.ashx',
    'POST',
    payload,
    onSuccess.bind(this),
    onError.bind(this)
  );

  function onSuccess(data) {
    if (!isEmpty(data)) {
      if (typeof data === 'string') {
        data = JSON.parse(data);
      }
    }
    new overlay();
    new viewMarketplaceModal({
      el: $('.designer-marketplace-overlay')[0],
      modelData: data
    });
    $('.component-loader').addClass('hide');
  }

  function onError(error) {
    console.log('error :', error);
  }
}

function getMarketPlaceTemplateDataUsingContrlID(controlID) {
  $('.component-loader').removeClass('hide');
  let payload = {
    operation: 'getTemplateMetaDataByControlID',
    control_id: controlID
  };
  commonFunction.fnAjaxRequest(
    url + 'Handler/DesignerTemplateHandler.ashx',
    'POST',
    payload,
    getTemplateSuccess.bind(this),
    getTemplateError.bind(this)
  );

  function getTemplateSuccess(data) {
    $('.component-loader').addClass('hide');
    if (!isEmpty(data)) {
      if (typeof data === 'string') {
        data = JSON.parse(data);
      }
      new overlay();
      new templateDetailModal({
        el: $('.designer-marketplace-overlay')[0],
        modelData: data
      });
    }
  }

  function getTemplateError(error) {
    console.log('error :', error);
  }
}

function openTemplatePreview(opts) {
  let templateID = opts.template_id;
  $('.component-loader').removeClass('hide');
  let payload = {
    operation: 'getDesignerTemplateByID',
    template_id: templateID
  };
  commonFunction.fnAjaxRequest(
    url + 'Handler/DesignerTemplateHandler.ashx',
    'POST',
    payload,
    onSuccess.bind(this),
    onError.bind(this)
  );

  function onSuccess(data) {
    if (!isEmpty(data)) {
      data = typeof data === 'string' ? JSON.parse(data) : data;
    }
    if ($('.designer-marketplace-overlay .preview-holder').length === 0) {
      $('.designer-marketplace-overlay').append(
        `<div class="preview-holder"></div>`
      );
    }
    new previewTemplateModal({
      el: $('.designer-marketplace-overlay .preview-holder')[0],
      modelData: data[0],
      group_name: opts.group_name
    });
    $('.component-loader').addClass('hide');
  }

  function onError(error) {
    console.log(error);
  }
}
export default {
  init: initialize,
  openMarketPlace: openDesignerTemplateModal,
  addupdateTemplate: getMarketPlaceTemplateDataUsingContrlID,
  openPreview: openTemplatePreview
};
